import { createSlice } from "@reduxjs/toolkit";

const driverSlice = createSlice({
  name: "driver",
  initialState: {
    initialValue: {
      search: "",
      company: "",
      subscription: "",
      tag: "",
    },
  },
  reducers: {
    setInitialValueFilter: (state, { payload }) => {
      state.initialValue = payload;
    },
  },
});
export const { setInitialValueFilter } = driverSlice.actions;
export default driverSlice.reducer;
